import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui className helper — kombinuje `clsx` + `tailwind-merge`.
 * Použitie: `cn("p-2", isActive && "bg-primary", className)`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
